var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgVatService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#VAT_Service_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.163 3.834a.358.358 0 0 0-.507 0L3.838 15.66a.358.358 0 1 0 .507.507L16.164 4.341a.358.358 0 0 0 0-.507ZM5.661 8.324a2.665 2.665 0 0 0 2.662-2.663A2.664 2.664 0 0 0 5.66 3 2.665 2.665 0 0 0 3 5.663a2.664 2.664 0 0 0 2.661 2.662v-.001Zm0-4.607c1.073 0 1.946.872 1.946 1.946A1.948 1.948 0 0 1 5.66 7.609a1.947 1.947 0 0 1-1.945-1.946c0-1.074.872-1.946 1.945-1.946ZM14.339 11.676a2.665 2.665 0 0 0-2.662 2.663A2.664 2.664 0 0 0 14.34 17 2.664 2.664 0 0 0 17 14.34a2.664 2.664 0 0 0-2.661-2.663Zm0 4.607a1.948 1.948 0 0 1-1.946-1.946c0-1.073.873-1.946 1.946-1.946 1.072 0 1.945.873 1.945 1.946a1.948 1.948 0 0 1-1.945 1.947Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "VAT_Service_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 3h14v14H3z"
})))));
const Memo = /*#__PURE__*/memo(SvgVatService);
export default Memo;